import type { FC } from 'react';

export enum SelectionStatus {
  None,
  PageSelected,
  AllSelected,
}

export interface SelectionStatusLineProps {
  status: SelectionStatus;
  numberSelectedOnPage: number;
  totalItems: number;
  onSelectAll: () => void;
  onClear: () => void;
}

export const SelectionStatusLine: FC<SelectionStatusLineProps> = ({
  status,
  numberSelectedOnPage,
  totalItems,
  onClear,
  onSelectAll,
}) => {
  const totalItemsLabel = totalItems.toLocaleString();

  // If no loans are selected, or all are selected, hide the status line
  if (numberSelectedOnPage === totalItems || status === SelectionStatus.None) {
    return null;
  }

  const renderContent = () => {
    switch (status) {
      case SelectionStatus.PageSelected:
        return (
          <>
            <span>
              All <b>{numberSelectedOnPage}</b> loans on this page are selected.
            </span>
            <button
              onClick={(e) => {
                e.preventDefault();
                onSelectAll();
              }}
              className="bg-transparent cursor-pointer border-0 text-white underline"
            >
              Select all <b>{totalItemsLabel}</b> loans that match this filter?
            </button>
          </>
        );

      case SelectionStatus.AllSelected:
        return (
          <>
            <span>
              All <b>{totalItemsLabel}</b> loans that match this filter are selected.
            </span>
            <button
              onClick={(e) => {
                e.preventDefault();
                onClear();
              }}
              className="bg-transparent cursor-pointer border-0 text-white underline"
            >
              Clear Selection
            </button>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="bg-blue-600 text-center">
      <div className="flex items-center justify-center gap-[30px] p-[10px] text-white">
        {renderContent()}
      </div>
    </div>
  );
};
